import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class HttpService {

  private readonly header = { headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }) };

  constructor(private readonly http: HttpClient) { }

 
  public postFormData<T>(url: string, body: any): Observable<T> {
    return this.http.post<T>(url, body)
      .pipe(catchError(err => this.handleError(err)));
  }

  public delete<T>(url: string, httpParams: HttpParams, header: HttpHeaders): Observable<T> {
    const httpOptions = {
      headers: header,
      params: httpParams
    };
    return this.http.delete<T>(url, httpOptions)
      .pipe(catchError(err => this.handleError(err)));
  }

  public post<T>(url: string, body: any, header: HttpHeaders): Observable<T> {
    const httpOptions = {
      headers: header
    };
    return this.http.post<T>(url, body, httpOptions)
      .pipe(catchError(err => this.handleError(err)));
  }

  public get<T>(url: string, header: HttpHeaders): Observable<T> {
    const httpOptions = {
      headers: header
    };
    return this.http.get<T>(url, httpOptions)
      .pipe(catchError(err => this.handleError(err)));
  }

  public handleError(error: HttpErrorResponse) {
    switch (error.status) {
      default:
        return throwError(error);
    }
  }
}
